import { Box, Tooltip } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { BORROWER_BACKGROUND_REVIEW_TYPE, BORROWER_CREDIT_REVIEW_TYPE } from '@roc/feature-utils';
import { Document } from '@roc/feature-types';
import { StandardDialog, Button } from '@roc/ui';
import { ResolutionForm } from 'libs/feature-borrower-review/src/components/utils/resolutionForm';
import { useResolutionStore } from 'libs/feature-borrower-review/src/hooks/useResolutionStore';
import { observer } from 'mobx-react';

export type ResolutionItemProps = {
  open?: boolean;
  onClose?: () => void;
  loanTaskId?: number;
  document?: Document;
};

export const ResolutionItem = observer((
  props: ResolutionItemProps
) => {
  const { open, onClose, loanTaskId, document } = props;
  const taskId = document?.taskId;
  const { resolutionStore } = useResolutionStore();
  const { tooltTipTitle } = resolutionStore;
  const { readOnly } = resolutionStore;
  // Background and credit resolutions carry their own title and explanation in the new layout.
  const hasNewLayout = [BORROWER_BACKGROUND_REVIEW_TYPE, BORROWER_CREDIT_REVIEW_TYPE].includes(resolutionStore.resolution?.objectType ?? '');
  const getTitle = () => {
    if (hasNewLayout) return null;
    return (
      <div>
        Provide Resolution
        <Tooltip
          placement="right"
          title={<p style={{ fontSize: '12px' }}> {tooltTipTitle} </p>}
        >
          <Help color="primary" style={{ fontSize: '18px', marginLeft: '3px', marginBottom: '10px' }} />
        </Tooltip>
      </div>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title='Resolution'
          handleClose={onClose}
          dialogContent={<div style={{ width: '100%' }}>
            {!hasNewLayout && <Box marginBottom={'24px'}>{getTitle()}</Box>}
            <ResolutionForm handleClose={onClose} loanTaskId={loanTaskId} readOnly={readOnly} />
          </div>}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title={getTitle()}
          maxWidth="sm"
          PaperProps={hasNewLayout ? { style: { maxWidth: 720, borderRadius: 24 } } : undefined}
          handleClose={onClose}
          dialogContent={<div style={{ marginTop: hasNewLayout ? 0 : '-40px' }}><ResolutionForm handleClose={onClose} loanTaskId={loanTaskId} readOnly={readOnly} /></div>}
        />
      )}
    </>
  );
});

export default ResolutionItem;
